export interface ServiceArea {
  name: string
  postcodes: string[]
  level: 'Premium' | 'Standard'
  color: string
}

export interface ServiceAreaTranslations {
  title: string
  subtitle: string
  form: {
    title: string
    description: string
    placeholder: string
    button: string
    success: string
    error: string
  }
  serviceLevels: {
    title: string
    premium: {
      title: string
      description: string
    }
    standard: {
      title: string
      description: string
    }
  }
  areas: {
    primary: {
      title: string
      description: string
      locations: string[]
    }
    secondary: {
      title: string
      description: string
      locations: string[]
    }
    extended: {
      title: string
      description: string
      locations: string[]
    }
  }
}

export const serviceAreaTranslations: Record<string, ServiceAreaTranslations> = {
  en: {
    title: 'My Service Area',
    subtitle: 'Check if I service your area in South Wales and learn about my different service levels',
    form: {
      title: 'Check Your Postcode',
      description: 'Enter your postcode to see if I service your area in South Wales',
      placeholder: 'Enter your postcode...',
      button: 'Check Area',
      success: 'Great news! I service your area ({area}) with my {level} service level.',
      error: "I'm sorry, but I don't currently service your area. Please contact me to discuss options."
    },
    serviceLevels: {
      title: 'Service Levels',
      premium: {
        title: 'Premium Service',
        description: 'Available in Barry, Penarth, Dinas Powys, and the Vale of Glamorgan. Includes priority scheduling and enhanced service options.'
      },
      standard: {
        title: 'Standard Service',
        description: 'Available in Cardiff, Bridgend, Swansea, Porthcawl, and surrounding South Wales areas. Comprehensive garden care and maintenance services.'
      }
    },
    areas: {
      primary: {
        title: 'Primary Service Area',
        description: 'Full range of services with quick response times',
        locations: ['Barry', 'Penarth', 'Dinas Powys', 'Vale of Glamorgan']
      },
      secondary: {
        title: 'Secondary Service Area',
        description: 'Most services available with slightly longer response times',
        locations: ['Cardiff', 'Bridgend', 'Cowbridge', 'Llantwit Major', 'Rhoose']
      },
      extended: {
        title: 'Extended Service Area',
        description: 'Limited services available - please contact me to discuss',
        locations: ['Swansea', 'Porthcawl', 'Newport', 'Caerphilly', 'Merthyr Tydfil', 'Pontypridd']
      }
    }
  },
  cy: {
    title: 'Fy Ardal Wasanaeth',
    subtitle: 'Gwirio a ydw i\'n gwasanaethu eich ardal yn De Cymru a dysgu am fy lefelau gwasanaeth gwahanol',
    form: {
      title: 'Gwirio Eich Cod Post',
      description: 'Rhowch eich cod post i weld a ydw i\'n gwasanaethu eich ardal yn De Cymru',
      placeholder: 'Rhowch eich cod post...',
      button: 'Gwirio Ardal',
      success: 'Newyddion da! Rwy\'n gwasanaethu eich ardal ({area}) gyda fy lefel wasanaeth {level}.',
      error: 'Mae\'n ddrwg gennyf, ond nid wyf yn gwasanaethu eich ardal ar hyn o bryd. Cysylltwch â mi i drafod opsiynau.'
    },
    serviceLevels: {
      title: 'Lefelau Gwasanaeth',
      premium: {
        title: 'Gwasanaeth Uwch',
        description: 'Ar gael ym Mhri, Penarth, Dinas Powys, a Bro Morgannwg. Yn cynnwys amserlennu blaenoriaethol ac opsiynau gwasanaeth uwch.'
      },
      standard: {
        title: 'Gwasanaeth Safonol',
        description: 'Ar gael yng Nghaerdydd, Pen-y-bont ar Ogwr, Abertawe, Porthcawl, ac ardaloedd cyfagos De Cymru. Gwasanaethau gofal a chynnal a chadw gardd cynhwysfawr.'
      }
    },
    areas: {
      primary: {
        title: 'Ardal Wasanaeth Sylfaenol',
        description: 'Ystod lawn o wasanaethau gydag amseroedd ymateb cyflym',
        locations: ['Y Barri', 'Penarth', 'Dinas Powys', 'Bro Morgannwg']
      },
      secondary: {
        title: 'Ardal Wasanaeth Eilaidd',
        description: 'Y rhan fwyaf o wasanaethau ar gael gydag amseroedd ymateb ychydig yn hirach',
        locations: ['Caerdydd', 'Pen-y-bont ar Ogwr', 'Y Bont-faen', 'Llantwit Major', 'Y Rhws']
      },
      extended: {
        title: 'Ardal Wasanaeth Estynedig',
        description: 'Gwasanaethau cyfyngedig ar gael - cysylltwch â mi i drafod',
        locations: ['Abertawe', 'Porthcawl', 'Casnewydd', 'Caerffili', 'Merthyr Tudful', 'Pontypridd']
      }
    }
  }
} 